export default class AccordionCarousel {
	constructor(wrapper) {

		this.ticker 					= wrapper
		this.slides 					= this.ticker.querySelectorAll('.accordion-carousel__slide')
		this.captions 					= this.ticker.querySelectorAll('.accordion-carousel__caption')
		this.init 						= this.init.bind(this)
		this.observeAccordionCarousel 	= this.observeAccordionCarousel.bind(this)
		this.changeSlides 				= this.changeSlides.bind(this)
		this.activeSlide 				= 0

		this.slides.forEach((slide, index) => {
			slide.addEventListener('click', () => {
				if(this.activeSlide === index) return
				this.changeSlides(this.activeSlide, index)
				clearInterval(this.timer) // End timer
				this.setTimer() // Restart timer
			})
		})

		this.init()

	}

	init() {

		this.observeAccordionCarousel()

	}

	// Only start the carousel timer when it is in view
	observeAccordionCarousel() {
		const observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					this.setTimer()
				} else {
					clearInterval(this.timer)
				}
			})
		}, {
			root: null,
			rootMargin: '0px',
			threshold: 0
		})

		observer.observe(this.ticker)
	}

	setTimer(){

		this.timer = setInterval(() => {
			if(this.activeSlide + 1 === this.slides.length) {
				this.changeSlides(this.activeSlide, 0)
				return;
			}
			this.changeSlides(this.activeSlide, this.activeSlide + 1)
		}, 5000)

	}

	changeSlides(prev, next) {
		this.slides[prev].classList.remove('active')
		this.slides[next].classList.add('active')
		this.captions[prev].classList.remove('active')
		this.captions[next].classList.add('active')
		this.activeSlide = next
	}
}
